// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1410":"ff49d939","2493":"d60c77a9","2658":"443dcf13","4505":"670dc5a3","5746":"ff49d939","7081":"443dcf13","9399":"443dcf13"}[chunkId] + ".chunk.css";
};